import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ProgramCard from '../components/ProgramCard';
import { impactPoints, programs, sponsors } from '../data/siteData';

const { FiArrowRight, FiHeart, FiUsers, FiBriefcase } = FiIcons;

function Home() {
  return (
    <>
      <section className="home-hero">
        <div className="hero-visual">
          <img
            src="/images/4.jpg"
            alt="Children enjoying a sunny outdoor day in the Pacific Northwest"
          />
        </div>

        <motion.div
          className="hero-copy"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <p className="eyebrow">Pacific Northwest · 501(c)(3)</p>
          <h1>Skills for today.<br /><em>Legacy for life.</em></h1>
          <p>
            We help disenfranchised youth build practical life skills, workforce
            confidence, and a lasting connection to their community.
          </p>
          <Link className="primary-button" to="/programs">
            Explore our programs <SafeIcon icon={FiArrowRight} />
          </Link>
        </motion.div>

        <div className="hero-badge">
          <SafeIcon icon={FiHeart} />
          <span>Learn.<br />Serve.<br />Lead.</span>
        </div>
      </section>

      <section className="impact-strip">
        {impactPoints.map((item) => (
          <div key={item.label}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </section>

      <section className="intro-section">
        <div>
          <p className="eyebrow">Our purpose</p>
          <h2>Potential is everywhere.<br />Opportunity should be too.</h2>
        </div>
        <div>
          <p>
            Legacy of Immortals creates accessible pathways for young people to
            learn, practice, and apply the skills that support independence and
            employment.
          </p>
          <Link className="text-link" to="/about">
            Meet the mission <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>
      </section>

      <section className="program-preview">
        <div className="section-heading">
          <p className="eyebrow">What we do</p>
          <h2>Programs built for real life.</h2>
        </div>
        <div className="program-grid">
          {programs.map((program, index) => (
            <ProgramCard
              key={program.title}
              program={program}
              featured={index === 0}
            />
          ))}
        </div>
      </section>

      <section className="service-banner">
        <div>
          <SafeIcon icon={FiUsers} />
          <SafeIcon icon={FiBriefcase} />
        </div>
        <h2>
          From community events to the workplace, youth learn by showing up and
          taking part.
        </h2>
        <Link to="/get-involved">
          Join the movement <SafeIcon icon={FiArrowRight} />
        </Link>
      </section>

      <section className="sponsors">
        <p className="eyebrow">Supported by community-minded organizations</p>
        <div>
          {sponsors.map((sponsor) => (
            <span key={sponsor}>{sponsor}</span>
          ))}
        </div>
      </section>
    </>
  );
}

export default Home;